<template>
  <div class="w-full flex flex-wrap font-primary">
        <div class="w-full sm:w-1/2 mb-4 pb-5 pt-5">
            <h2 class="font-fancy text-4xl">INICIAR SESIÓN</h2>
            <p>Si ya tenés cuenta podés ingresar completando los campos.</p>
            <div class="p-2">
                <div class="flex justify-center">
                  <input placeholder="CUIT" type="text" class="form-control w-2/3" v-model="user">
                </div>
            </div>
            <div class="p-2">
                <div class="flex justify-center">
                  <div class="w-2/3 flex">
                    <input v-on:keyup.enter="enviar" placeholder="Contraseña" :type="mostrar ? 'text' : 'password'" class="form-control" v-model="pass">
                    <button class="w-10 h-10 border rounded-sm" @click="mostrar = !mostrar"><img class="h-9" src="../assets/eye.jpg"></button>
                  </div>
                </div>
            </div>
            <p class="text-red-500" v-if="errorLogin">{{ errorLogin }}</p>
            <div class="flex flex-wrap gap-5 justify-center content-center">
              <RouterLink :to="'/olvide-mi-contrasena'" class="mt-2">Olvidaste tu contraseña?</RouterLink>
              <button class="btn btn-danger bg-truered mt-2" @click="enviar">INGRESAR</button>
            </div>
        </div>



        <div class="border-t border-black-200 w-full sm:w-1/2 pb-5 pt-5">
          <h2 class="font-fancy text-4xl">REGISTRATE</h2>
          <p>Todavía no tenés cuenta? completá los siguientes campos para obtenerla.</p>

          <p class="text-red-500" v-if="errorRegistro">{{ errorRegistro }}</p>

          <div class="flex justify-center p-2">
            <input placeholder="CUIT" type="text" class="form-control w-2/3" v-model="registro.cuit" @change="buscarCuit()">
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="E-mail" type="text" class="form-control w-2/3" v-model="registro.email">
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="Contraseña" :type="mostrar ? 'text' : 'password'" class="form-control w-[62%]" v-model="registro.contra">
            <button class="w-10 h-10 border rounded-sm" @click="mostrar = !mostrar"><img class="h-9" src="../assets/eye.jpg"></button>
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="Confirmar Contraseña" :type="mostrar ? 'text' : 'password'" class="form-control w-2/3" v-model="registro.confirmar">
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="Nombre" type="text" class="form-control w-2/3" v-model="registro.nombre">
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="Apellido" type="text" class="form-control w-2/3" v-model="registro.apellido">
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="Razón social" type="text" class="form-control w-2/3" v-model="registro.razonSocial" readonly>
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="Teléfono" type="phone" class="form-control w-2/3" v-model="registro.telefono">
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="Celular" type="phone" class="form-control w-2/3" v-model="registro.celular">
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="Dirección de entrega" style="display: none;" id="direccion" autocomplete="off" ref="autocompleteInput" type="text" class="form-control w-2/3">
            <input placeholder="Dirección de entrega" id="none" autocomplete="off" ref="autocompleteInput" type="text" class="form-control w-2/3" v-model="registro.direccion">
          </div>
          <div class="flex justify-center p-2">
            <select placeholder="Seleccione una provincia" class="form-select w-2/3" v-model="registro.provincia">
              <option value="" disabled selected hidden>Seleccione una provincia</option>
              <option v-for="(prov, key) in provincias" :key="key" :value="prov.id">{{ prov.descripcion }}</option>
            </select>
          </div>
          <div class="flex justify-center p-2">
            <input placeholder="Localidad" id="ciudad" type="text" class="form-control w-2/3" v-model="registro.localidad">
          </div>
          <div class="flex justify-center p-2">
            <select placeholder="Seleccione un expreso" class="form-select w-2/3" v-model="registro.expreso">
              <option value="" disabled selected hidden>Seleccione un expreso</option>
              <option v-for="(ex, key) in expresos" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
            </select>
          </div>
          <div class="flex justify-center p-2">
            <textarea rows="3" placeholder="Observaciones" class="form-control w-2/3" v-model="registro.observacion"></textarea>
          </div>
          <div class="flex justify-center p-2 gap-2">
            <input type="checkbox" class="form-checkbox" v-model="registro.terminos">
            <p>Acepto los <RouterLink target='_blank' :to="'/terminos'" class="underline">términos y condiciones de uso</RouterLink></p>
          </div>

          <p class="text-red-500" v-if="errorRegistro">{{ errorRegistro }}</p>
          <button class="btn btn-danger bg-truered mt-2" :disabled="loading || loadingCuit || !padronValido" @click="register">CREAR CUENTA</button>
        </div>
  </div>      
</template>

<script>
// import authService from '@/services/auth.service';
import authService from '@/services/auth.service';
import { applyPadronToRegistro } from '@/utils/afipPadron';
import { defineComponent } from 'vue';

export default defineComponent({
    mounted() {
      this.initAutocomplete()
      this.getExpresos()
      // TODO: faltan los expresos
    },
    data() {
        return {
            loading: false,
            user: '',
            pass: '',
            mostrar: false,
            errorLogin: '',
            errorRegistro: '',
            loadingCuit: false,
            padronValido: false,
            cuitConsultado: '',
            registro: {
              email: '',
              contra: '',
              confirmar: '',
              cuit: '',
              nombre: '',
              apellido: '',
              razonSocial: '',
              celular: '',
              telefono: '',
              direccion: '',
              places: {},
              expreso: '1',
              provincia: '',
              ciudad: '',
              observacion: '',
              terminos: false
            },
            expresos: [],
            provincias: [
              { id: 0, descripcion: "CABA" }, // Ciudad Autónoma de Buenos Aires
              { id: 1, descripcion: "Buenos Aires" },
              { id: 2, descripcion: "Catamarca" },
              { id: 3, descripcion: "Córdoba" },
              { id: 4, descripcion: "Corrientes" },
              { id: 5, descripcion: "Entre Ríos" },
              { id: 6, descripcion: "Jujuy" },
              { id: 7, descripcion: "Mendoza" },
              { id: 8, descripcion: "La Rioja" },
              { id: 9, descripcion: "Salta" },
              { id: 10, descripcion: "San Juan" },
              { id: 11, descripcion: "San Luis" },
              { id: 12, descripcion: "Santa Fe" },
              { id: 13, descripcion: "Santiago del Estero" },
              { id: 14, descripcion: "Tucumán" },
              { id: 16, descripcion: "Chaco" },
              { id: 17, descripcion: "Chubut" },
              { id: 18, descripcion: "Formosa" },
              { id: 19, descripcion: "Misiones" },
              { id: 20, descripcion: "Neuquén" },
              { id: 21, descripcion: "La Pampa" },
              { id: 22, descripcion: "Río Negro" },
              { id: 23, descripcion: "Santa Cruz" },
              { id: 24, descripcion: "Tierra del Fuego" },
            ],
            ciudades: []
        }
    },
    methods: {
        buscarCuit() {
          if (this.registro.cuit) {
            this.loadingCuit = true
            this.padronValido = false
            this.cuitConsultado = ''
            this.registro.razonSocial = ''
            authService.getPadron(this.registro.cuit)
              .then((res) => {
                this.loadingCuit = false
                console.log(res.data)
                if (res.data.cuit) {
                  if (this.errorRegistro == 'El cuit ingresado es invalido') {
                    this.errorRegistro = ''
                  }
                  applyPadronToRegistro(this.registro, res.data)
                  if (this.registro.razonSocial) {
                    this.padronValido = true
                    this.cuitConsultado = String(this.registro.cuit)
                  } else {
                    this.errorRegistro = 'AFIP no devolvió razón social para el CUIT ingresado'
                  }
                } else {
                  this.errorRegistro = 'El cuit ingresado es invalido'
                }
              })
              .catch((err) => {
                this.loadingCuit = false
                console.log(err)
                this.errorRegistro = 'El cuit ingresado es invalido'
              })
          }
        },
        initAutocomplete() {
          const input = this.$refs.autocompleteInput;
          const options = {
            types: ['geocode'], // Limit results to addresses
            componentRestrictions: { country: 'AR' }
          };

          const autocomplete = new window.google.maps.places.Autocomplete(input, options);

          autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace()
            console.log(place)
            if (place && place.formatted_address) {
              // place.formatted_address

              for (const component of place.address_components) {
                const componentType = component.types[0]; // Each component can have multiple types, we use the first one

                switch (componentType) {
                  case 'street_number':
                    this.registro.places.numero = component.long_name
                    console.log('Street Number:', component.long_name);
                    break;
                  case 'route':
                    this.registro.places.calle = component.long_name
                    console.log('Street Name:', component.long_name);
                    break;
                  case 'intersection':
                    this.registro.places.interseccion = component.long_name
                    console.log('Intersection:', component.long_name);
                    break;
                  case 'locality':
                    this.registro.localidad = component.long_name
                    console.log('City:', component.long_name);
                    break;
                  case 'administrative_area_level_1':
                    this.registro.places.ciudad = component.long_name
                    console.log('State:', component.short_name);
                    break;
                  case 'postal_code':
                    this.registro.places.cp = component.long_name
                    console.log('Postal Code:', component.long_name);
                    break;
                  case 'country':
                    this.registro.places.pais = component.long_name
                    console.log('Country:', component.long_name);
                    break;
                }
              }
              this.registro.direccion = (this.registro.places.calle ? this.registro.places.calle : '') + ' ' + (this.registro.places.numero ? this.registro.places.numero : '') + ' ' + (this.registro.places.interseccion ? this.registro.places.interseccion : '')
            }
          })
        },
        getExpresos() {
          authService.expresos()
            .then((res) => {
              this.expresos = res.data.map(x => ({
                id: x.ID_EXP,
                descripcion: x.NOMBRE_EXP
              })).sort((a, b) => {
                const descripcionA = a.descripcion.toLowerCase();
                const descripcionB = b.descripcion.toLowerCase();

                if (descripcionA < descripcionB) {
                  return -1;
                }
                if (descripcionA > descripcionB) {
                  return 1;
                }
                return 0;
              })
            })
            .catch(err => {
              console.log(err)
            })
        },
        enviar() {
          this.errorLogin = ''
          var user = {
              username: this.user,
              password: this.pass
          }
          this.$store.dispatch('auth/login', user)
            .then(res => {
              console.log(res)
              this.$root.inicialize()
              this.$router.push('/catalogo')
            })
            .catch(e => {
              this.errorLogin = 'Los datos ingresados son incorrectos'
              console.log(e)
            })  
        },

        register() {
          this.loading = true
          var usuario = this.registro
          usuario.direccion = this.registro.direccion.direccion ? this.registro.direccion.direccion : this.registro.direccion 
          usuario.ciudad = this.registro.direccion.ciudad ? this.registro.direccion.ciudad : this.registro.localidad 
          if (!usuario.terminos) {
            this.errorRegistro = 'Debe aceptar los términos y condiciones'
          } else {
            if (this.errorRegistro == 'Debe aceptar los términos y condiciones') {
              this.errorRegistro = ''
            }
          }
          if (!usuario.email) {
            this.errorRegistro = 'Debe ingresar un email válido'
          } else {
            if (this.errorRegistro == 'Debe ingresar un email válido' || this.errorRegistro == 'El email ingresado ya esta en uso') {
              this.errorRegistro = ''
            }
          }
          if (!usuario.contra) {
            this.errorRegistro = 'Debe ingresar una contraseña válida'
          } else {
            if (this.errorRegistro == 'Debe ingresar una contraseña válida') {
              this.errorRegistro = ''
            }
          }
          if (!usuario.expreso) {
            this.errorRegistro = 'Debe ingresar un EXPRESO válido'
          } else {
            if (this.errorRegistro == 'Debe ingresar un EXPRESO válido' || this.errorRegistro == 'El CUIT ingresado ya esta en uso') {
              this.errorRegistro = ''
            }
            usuario.idexp = usuario.expreso
          }
          if (!usuario.cuit) {
            this.errorRegistro = 'Debe ingresar un CUIT válido'
          } else {
            if (this.errorRegistro == 'Debe ingresar un CUIT válido' || this.errorRegistro == 'El CUIT ingresado ya esta en uso') {
              this.errorRegistro = ''
            }
          }
          if (!this.padronValido || String(usuario.cuit) !== this.cuitConsultado) {
            this.errorRegistro = 'Debe consultar un CUIT válido en AFIP antes de registrarse'
          } else {
            if (this.errorRegistro == 'Debe consultar un CUIT válido en AFIP antes de registrarse') {
              this.errorRegistro = ''
            }
          }
          if (usuario.contra != usuario.confirmar) {
            this.errorRegistro = 'Las contraseñas no coinciden'
          } else {
            if (this.errorRegistro == 'Las contraseñas no coinciden') {
              this.errorRegistro = ''
            }
          }
          // Validaciones de campos que deberían completarse con AFIP
          if (!usuario.razonSocial || usuario.razonSocial.trim() === '') {
            this.errorRegistro = 'Debe ingresar una razón social'
          } else {
            if (this.errorRegistro == 'Debe ingresar una razón social') {
              this.errorRegistro = ''
            }
          }
          if (!usuario.direccion || usuario.direccion.trim() === '') {
            this.errorRegistro = 'Debe ingresar una dirección'
          } else {
            if (this.errorRegistro == 'Debe ingresar una dirección') {
              this.errorRegistro = ''
            }
          }
          if (!usuario.provincia && usuario.provincia !== 0) {
            this.errorRegistro = 'Debe seleccionar una provincia'
          } else {
            if (this.errorRegistro == 'Debe seleccionar una provincia') {
              this.errorRegistro = ''
            }
          }
          if (!usuario.ciudad || usuario.ciudad.trim() === '') {
            this.errorRegistro = 'Debe ingresar una localidad'
          } else {
            if (this.errorRegistro == 'Debe ingresar una localidad') {
              this.errorRegistro = ''
            }
          }
          // agregar validaciones
          if (this.errorRegistro == '' || this.errorRegistro == 'No se pudo realizar el registro, intente nuevamente' ) {
            authService.signup(usuario)
              .then((res) => {
                this.loading = false
                console.log(res)
                this.$root.alertSuccess = true
                this.$root.isAlertVisible = true
                this.$router.push('/esperando-habilitacion')
              })
              .catch(err => {
                this.loading = false
                console.log(err)
                if (err.response && err.response.status === 403) {
                  this.errorRegistro = err.response.data
                } else if (err.response && (err.response.status === 400 || err.response.status === 502)) {
                  this.errorRegistro = err.response.data || 'No se pudo validar el CUIT con AFIP'
                } else {
                  this.errorRegistro = 'No se pudo realizar el registro, intente nuevamente'
                }
              })
          } else {
            this.loading = false
          }
        }
    }
})
</script>
